import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import ProgramMembershipService from '../../services/program-membership';
import { ProgramMembership } from '../../models/program-membership/types';
import { useEffect } from 'react';
import { redirectToLogin } from '../../lib/auth';
import { AxiosError } from 'axios';

/**
 * Query key for program membership
 */
export const PROGRAM_MEMBERSHIP_QUERY_KEY = ['programMembership'];

/**
 * Fetch program membership data from mojo
 *
 * @param options - Optional React Query options
 * @returns Query result with program membership data
 */
export const useProgramMembershipQuery = (
  options?: Omit<
    UseQueryOptions<ProgramMembership, Error, ProgramMembership, string[]>,
    'queryKey' | 'queryFn'
  >
) => {
  const query = useQuery<ProgramMembership, Error, ProgramMembership, string[]>(
    {
      queryKey: PROGRAM_MEMBERSHIP_QUERY_KEY,
      queryFn: async () => {
        const response = await new ProgramMembershipService().fetch();
        return response.data.program_memberships[0];
      },
      keepPreviousData: true,
      ...options,
    }
  );

  useEffect(() => {
    if (query.error && query.error instanceof AxiosError) {
      if (
        query.error.response?.status === 401 ||
        query.error.response?.status === 403
      ) {
        redirectToLogin();
      }
    }
  }, [query.error]);

  return query;
};
